import script from "./CatalogoCodigosPresupuesto.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogoCodigosPresupuesto.vue?vue&type=script&setup=true&lang=js"

import "./CatalogoCodigosPresupuesto.vue?vue&type=style&index=0&id=d34bac10&lang=scss&scoped=true"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\18\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d34bac10"]])

export default __exports__